import { fromWeb, requiredStr } from "@protomodule/instruments"

export const config = fromWeb({
  REACT_APP_GRAPHQL_ENDPOINT: requiredStr(),
  REACT_APP_GRAPHQL_SUBSCRIPTION_ENDPOINT: requiredStr(),
  REACT_APP_GOOGLE_MAPS_API_KEY: requiredStr(),
  REACT_APP_DEFAULT_DOCUMENT_DELETION_RANGE_IN_DAYS: requiredStr(),
  REACT_APP_ACTIVE_LANGUAGES: requiredStr(),
})
